var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-840.000000, -4178.000000) translate(840.000000, 3571.000000) translate(0.000000, 573.000000) translate(0.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B79504",
    d: "M12 18.205V24c1.6 0 2.897-1.297 2.897-2.897 0-1.6-1.297-2.898-2.897-2.898z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3AB02",
    d: "M13.449 21.103c0-1.6-.649-2.898-1.449-2.898-1.6 0-2.897 1.297-2.897 2.898C9.103 22.703 10.4 24 12 24c.8 0 1.449-1.297 1.449-2.897z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 1.449,
    r: 1.449,
    fill: "#E0B500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B79504",
    d: "M19.441 14.518l-2.897-1.449 4.559 6.585h1.448c0-2.232-1.261-4.168-3.11-5.136z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E0B500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.544 13.07l-5.993-2.898-7.441 2.897C1.262 14.037 0 15.974 0 18.205h19.654c0-2.231-1.262-4.168-3.11-5.136z",
    transform: "translate(1.448672, 1.448672)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.67 5.165C16.173 2.233 13.623 0 10.55 0c-.245 0-.486.014-.724.042l6.717 13.027h1.449l-1.324-7.904z",
    transform: "translate(1.448672, 1.448672)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F9C900"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.276 0C8.534.319 6.337 2.425 5.882 5.123l-1.323 7.904h13.434l-1.324-7.904C16.214 2.425 14.018.32 11.276 0zM24 18.888c0-.4-.324-.725-.724-.725H.724c-.4 0-.724.325-.724.725 0 .4.324.724.724.724h22.552c.4 0 .724-.324.724-.724z",
    transform: "translate(0.000000, 1.490672)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 1.449,
    r: 1,
    fill: "#B79504"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b1c87752.svg";
export { ForwardRef as ReactComponent };